const LoginRoute = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../../views/Login/Index.vue'),
  },
];

export default LoginRoute;
